import styled from 'styled-components';
export const Choice = styled.label`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 0;
  cursor: pointer;
  line-height: 1.5;
  input {
    margin-top: 5px;
    accent-color: ${({ theme }) => theme.color.textPrimary};
  }
  small {
    display: block;
    color: ${({ theme }) => theme.color.textMuted};
  }
  select {
    min-width: 0;
    max-width: 100%;
    font: inherit;
    background: ${({ theme }) => theme.color.surface};
    color: ${({ theme }) => theme.color.textPrimary};
    border: 1px solid ${({ theme }) => theme.color.hairSoft};
    border-radius: ${({ theme }) => theme.radius.sm};
    padding: 8px;
  }
`;
export const Footer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
  flex-wrap: wrap;
`;
export const Hint = styled.p`
  color: ${({ theme }) => theme.color.textMuted};
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1.5;
  margin: 8px 0;
`;
